import * as T from 'three';
import { Plane, getBestPlane } from '../dataAnalysis/plane';
import { exportToCsv, getColorFromRamp } from '../helpers';
import { Line3D, Line3D_OLD } from "../robotFunctions/3dLine";
import { ModifyRobotColor } from '../robotFunctions/robotHelpers';
import { TextBox, FileUploader, Select, Checkbox, Button, Slider, Container, TextInput } from '../ui/pageElements';

const HEADER_CONTAINER = "lineListHeaderContainer";
const LIST_CONTAINER = "lineListContainer";

export class LineInterface {
    constructor(scene, interfaces) {

        this.scene = scene;
        this.allLines = [];
        this.currLine;
        this.newLineButton;
        this.clearAllLinesButton;
        this.interfaces = interfaces;
        this.focusJoint;
        this.rgbMain = 0;

        this.buttonsContainer = new Container("lineButtonContainer", HEADER_CONTAINER);

        this.clearAllLinesButton = new Button("Clear All Lines", HEADER_CONTAINER, () => {
            this.currLine = null;
            this.allLines.forEach(group => {
                group.line.clearLine();
                group.container.removeDiv();
                group.plane.deletePlane()
                group.ghosts.forEach(ghost => {
                    this.scene.remove(ghost)
                })
            })
            this.allLines = [];
        });
        this.clearAllLinesButton.setToolTip(this.interfaces.tooltips.clearAllLines, "leftToolTip");

        this.buttonsContainer.addBlock(this.clearAllLinesButton);
    }

    createNewLine(robotGroup) {
        // generate color for line
        let generateRandomColor = () => {
            let rgb = [Math.random() / 3 + .1, Math.random() / 3 + .1, Math.random() / 3 + .1];
            if (this.rgbMain >= 3) {
                rgb[0] += .5;
                rgb[1] += .5;
                rgb[2] += .5;
                rgb[this.rgbMain - 3] -= .5;
            } else {
                rgb[this.rgbMain] += .5;
            }
            this.rgbMain = (this.rgbMain + 1) % 6;
            return new T.Color(rgb[0], rgb[1], rgb[2]);
        }

        let colors = [generateRandomColor(), generateRandomColor()]

        let line = new Line3D(this.scene, robotGroup, colors);
        let sideLines = []
        robotGroup.dataInterface.jointSpheres.forEach(joint => {
            let sLine = new Line3D(this.scene, robotGroup, colors)
            sideLines.push([joint, sLine])
        })

        let plane = new Plane(this.scene, new T.Vector3(), new T.Vector3(0, 1, 0), "yellow")
        plane.setVisible(false)
        let lineGroup;
        let container = new Container("lineContainer", LIST_CONTAINER, true);

        // line data
        let lineRobotNameText = new TextBox("lineRobotName", LIST_CONTAINER, "Robot: " + robotGroup.robotName);
        let lineAnimationText = new TextBox("lineAnimationName", LIST_CONTAINER, "Motion: " + this.interfaces.animation.getSelectedAnimationName());
        let lineEndEffectorText = new TextBox("lineEndEffectorName", LIST_CONTAINER, "End Effector: " + robotGroup.getEndEffector().name);
        lineRobotNameText.setToolTip("Robot Name: " + robotGroup.robotName, "leftToolTip");
        lineAnimationText.setToolTip("Motion: " + this.interfaces.animation.getSelectedAnimationName(), "leftToolTip");
        lineEndEffectorText.setToolTip("End Effector: " + robotGroup.getEndEffector().name, "leftToolTip");

        let ghosts = []

        // end line button
        let deleteButton = new Button("Stop Drawing", LIST_CONTAINER, () => {
            let index = this.allLines.indexOf(lineGroup);
            this.allLines.splice(index, 1);
            line.clearLine();
            sideLines.forEach(l => {
                l[1].clearLine();
            })
            container.removeDiv();
            plane.deletePlane();
            ghosts.forEach(ghost => {
                this.scene.remove(ghost)
            })
        })
        deleteButton.setToolTip(this.interfaces.tooltips.deleteButton, "leftToolTip");

        // hide button
        let hideButton = new Button("Hide Line", LIST_CONTAINER, () => {
            let index = this.allLines.indexOf(lineGroup);
            if (this.allLines[index].visible) {
                this.allLines[index].hideButton.button.innerHTML = "Show Line";
                this.allLines[index].visible = false;
                line.hideLine();
                sideLines.forEach(l => {
                    l[1].hideLine();
                })
                plane.setVisible(false)
                ghosts.forEach(ghost => {
                    ghost.visible = false
                })
            }
            else {
                this.allLines[index].hideButton.button.innerHTML = "Hide Line";
                this.allLines[index].visible = true;
                line.showLine();
                if(this.allLines[index].showMultiLines) {
                    sideLines.forEach(l => {
                        l[1].showLine();
                    })   
                }
                ghosts.forEach(ghost => {
                    ghost.visible = true
                })
                // plane.setVisible(true)
            }
        })
        hideButton.setToolTip(this.interfaces.tooltips.hideButton, "leftToolTip");

        // line color type
        let colorModeSelect = new Select("Line Type", LIST_CONTAINER, [
            ["Time", 0],
            ["Velocity", 1],
            ["Time (Different Ramp)", 2],
            ["Velocity (Different Ramp)", 3]
        ])
        colorModeSelect.select.onchange = () => {
            line.recolor(colorModeSelect.getSelectedIndex());
        }
        colorModeSelect.setToolTip(this.interfaces.tooltips.lineType, "leftToolTip");

        // // line width input
        // let lineWidthText = new TextInput("Line Width", LIST_CONTAINER, "0.003");
        // lineWidthText.textInput.onchange = () => {
        //     let width = Number(lineWidthText.textInput.value);
        //     if (isNaN(width)) {
        //         width = 0.003;
        //         lineWidthText.textInput.value = width;
        //     }
        //     line.setLineWidth(width);
        // }
        // lineWidthText.setToolTip(this.interfaces.tooltips.lineWidth, "leftToolTip");

        // multi line show
        let hideSidesButton = new Button("Show Multi Lines", LIST_CONTAINER, () => {
            let index = this.allLines.indexOf(lineGroup);
            if(this.allLines[index].showMultiLines) {
                this.allLines[index].hideSidesButton.button.innerHTML = "Show Mulit Lines";
                sideLines.forEach(l => {
                    l[1].hideLine();
                })
                this.allLines[index].showMultiLines = false
            } else {
                sideLines.forEach(l => {
                    this.allLines[index].hideSidesButton.button.innerHTML = "Hide Muliti Line";
                    l[1].showLine();
                })
                this.allLines[index].showMultiLines = true
            }
        })

        // time cycle input
        let timeCycleText = new TextInput("Time Cycle", LIST_CONTAINER, "1");
        timeCycleText.textInput.onchange = () => {
            let cycle = Number(timeCycleText.textInput.value);
            if (isNaN(cycle)) {
                cycle = 1;
                timeCycleText.textInput.value = cycle;
            }
            line.setTimeCycle(cycle);
        }
        timeCycleText.setToolTip(this.interfaces.tooltips.timeCycle, "leftToolTip");

        // container for end and hide button
        let buttonContainer = new Container("buttonContainer", LIST_CONTAINER);
        buttonContainer.addBlock(deleteButton, hideButton);

        // container for line width and time cycle
        let settingsContainer = new Container("lineSettingsContainer", LIST_CONTAINER);
        // settingsContainer.addBlock(lineWidthText, timeCycleText);
        settingsContainer.addBlock(hideSidesButton, timeCycleText);

        container.addBlock(lineRobotNameText, lineAnimationText, lineEndEffectorText, buttonContainer, colorModeSelect, settingsContainer);
        container.div.style.border = "solid red";
        container.div.style.borderColor = colors[0].getStyle();
        lineGroup = {
            line: line,
            sideLines: sideLines,
            deleteButton: deleteButton,
            isDrawing: true,
            container: container,
            visible: true,
            hideButton: hideButton,
            hideSidesButton: hideSidesButton,
            colorModeSelect: colorModeSelect,
            motionName: this.interfaces.animation.animationPicker.getSelectedName(),
            robotGroup: robotGroup,
            plane: plane,
            ghosts: ghosts,
            ghostTimes: [],
            showMultiLines: false,
            colors: colors
        }
        this.allLines.forEach(group => {
            group.deleteButton.button.innerHTML = "Delete Line";
            group.isDrawing = false;
        })
        this.allLines.push(lineGroup)
        this.currLine = line;
        this.currLineGroup = lineGroup;
    }

    getCurrentLine() {
        return this.currLine;
    }

    getAllLineMeshes() {
        return this.allLines.map(group => group.line.mesh).filter(mesh => mesh != null);
    }

    getAllLines() {
        return this.allLines;
    }

    updateLine(time, updateMesh = true) {
        if (this.currLine) {
            if (updateMesh) {
                this.currLine.updateLine(this.interfaces.robot.getSelectedRobotGroup().getEndEffector().getWorldPosition(new T.Vector3()), time);
                this.currLineGroup.sideLines.forEach(l => {
                    l[1].updateLine(l[0].getWorldPosition(new T.Vector3()), time)
                })
            } else {
                this.currLine.addPoint(this.interfaces.robot.getSelectedRobotGroup().getEndEffector().getWorldPosition(new T.Vector3()), time);
                this.currLineGroup.sideLines.forEach(l => {
                    l[1].addPoint(l[0].getWorldPosition(new T.Vector3()), time)
                })
            }
        }
    }

    addGhost(ghost, time) {
        if(this.currLineGroup) {
            this.currLineGroup.ghosts.push(ghost)
            this.currLineGroup.ghostTimes.push(time)
        }
    }

    endCurrentLine(hideLine = false) {
        this.allLines.forEach(group => {
            group.deleteButton.button.innerHTML = "Delete Line";
            group.isDrawing = false;
        })
        // get best plane
        if(this.currLine) {
            let planeData = getBestPlane(this.currLine.points)
            this.currLineGroup.plane.updatePlane(planeData.point, planeData.normal)
            this.currLineGroup.robotGroup.dataInterface.addMotionPlane(this.currLineGroup.motionName, this.currLineGroup.plane)

            this.currLine.setTimeCycle(-1)
            let range = this.currLine.getRange()
            console.log(range, range.maxTime - range.minTime)
            for(let i = 0; i < this.currLineGroup.ghosts.length; i++) {
                let ramp = this.currLine.getColorRamp()
                let t = (this.currLineGroup.ghostTimes[i] - range.minTime) / (range.maxTime - range.minTime)
                t = t < 0 ? 0 : t
                let color = getColorFromRamp(ramp, t)
                ModifyRobotColor(this.currLineGroup.ghosts[i], color, 0.7)
            }
            if(hideLine) {
                if (this.currLineGroup.visible) {
                    this.currLineGroup.hideButton.button.innerHTML = "Show Line";
                    this.currLineGroup.visible = false;
                    this.currLine.hideLine();
                    this.currLineGroup.plane.setVisible(false)
                    this.currLineGroup.ghosts.forEach(ghost => {
                        ghost.visible = false
                    })
                }
            }
    
            this.currLineGroup.sideLines.forEach(l => {
                l[1].setTimeCycle(-1)
                l[1].hideLine();
            })

        }

        this.currLine = null;
        this.currLineGroup = null;
    }

    getLinesJSON() {
        let lineGroups = [];
        this.allLines.forEach(group => {
            lineGroups.push({
                robotName: group.robotGroup.robot.robotName,
                motionName: group.motionName,
                colors: group.line.colors,
                minTime: group.line.minTime,
                maxTime: group.line.maxTime,
                width: group.line.lineWidth
            })
        })
        return lineGroups;
    }
}